const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/leads/all',
    authenticatedEntryPathAdminExpert: '/app/leads/all',
    authenticatedEntryPathStandard: '/app/leads/all',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig